import _ from 'lodash';

export const getUserIdForFilter = state => {
    const {
        user: { userId }
    } = state;
    return userId;
};
export const getUserFromState = state => state.user;
export const getUserIdFromState = state => state.user.userId;

export const getBrowsingHistoryFromState = state => _.get(state, 'user.browsingHistory', []);
